import { letter } from 'Constants/letter.constants'
import * as letterLogo from 'Assets/img/logo.png'
import { get } from 'lodash'
import { getDate, getTime } from 'Helpers'
import { ActModel, ActStatuses } from 'Pages/acts'

export const getSignActProtocolTemplate = (item: ActModel): any => {
	const {
		partner_signing_at,
		partner,
		id,
		ds_signing_at,
		act_date,
		certificate_info,
		filename,
		partner_signer,
		partner_signer_phone,
		partner_signer_position,
		status,
	} = item

	const slug = status?.status_slug
	const on_signing =
		slug === ActStatuses.SIGNED || slug === ActStatuses.ON_DS_SIGNING || ActStatuses.PAID
	const on_annul_ds = slug === ActStatuses.ANNUL || slug === ActStatuses.ON_ANNUL_DS
	const annul = on_annul_ds ? 'аннулирования ' : ''

	const opening = {
		rows: [
			`Протокол составлен: ${getDate(partner_signing_at)} ${getTime(partner_signing_at)}`,
			'Поставщик услуги: АО "Деловая среда"',
			'Информационная система: Новое Единое окно',
		],
		x: 15,
		y: 10,
	}
	const heading = {
		text: `Протокол ${annul}${on_signing ? 'передачи ' : ''}документа в электронном виде`,
		x: 85,
		y: 60,
	}
	const subHeading = {
		text: `Акт сдачи-приемки оказанных услуг № б/н от ${getDate(act_date)}`,
		x: 100,
		y: 70,
	}

	const body = {
		rows: [
			{
				key: 'Агент',
				value: `${get(partner, 'name_full', '')} ИНН: ${get(partner, 'vat_number', '')}`,
			},
			{
				key: 'Принципал',
				value: 'АО "ДЕЛОВАЯ СРЕДА" ИНН: 7736641983 КПП: 773601001',
			},
			{
				key: 'Имя файла',
				value: filename,
			},
			{
				key: 'Идентификатор документа в ИС НЕО',
				value: `${id}`,
			},
			{
				key: 'Дата формирования акта',
				value: `${getDate(act_date)}`,
			},
			{
				key: `Дата ${annul}${on_signing ? 'подписания ' : ''}акта агентом`,
				value: `${getDate(partner_signing_at)}`,
			},
			{
				key: `Дата ${annul}${on_signing ? 'подписания ' : ''}акта АО «Деловая среда»`,
				value: `${getDate(ds_signing_at)}`,
			},
		],
		x: 15,
		y: 85,
	}

	const getTableBody = (): any[] => {
		const result = [
			[
				'1',
				`${get(partner, 'name_full', '')}`,
				'Простая электронная подпись',
				`${partner_signer_position}`,
				`${partner_signer}`,
				`${getDate(partner_signing_at)}`,
				`Разовый код sms на номер ${partner_signer_phone}`,
				'Успешно подписано',
			],
		]
		if (ds_signing_at && (on_signing || on_annul_ds)) {
			let subjectName = get(certificate_info, 'subjectName', null)
			const dsSigner: any = {}
			let ds_signer_name = ''
			let ds_signer_position = ''
			if (subjectName) {
				subjectName = subjectName.split(', ')
				subjectName.forEach((i: string): void => {
					const [key, value] = i.split('=')
					dsSigner[key] = value
				})
				ds_signer_name = `${get(dsSigner, 'SN', '')} ${get(dsSigner, 'G', '')}`
				ds_signer_position = `${get(dsSigner, 'T', '')}`
			}
			result.push([
				'2',
				'АО "Деловая среда"',
				'Квалифицированная электронная подпись',
				`${ds_signer_position}`,
				`${ds_signer_name}`,
				`${getDate(ds_signing_at)}`,
				`Серийный номер сертификата ${get(certificate_info, 'thumbprint', '')}`,
				'Успешно подписано',
			])
		}
		return result
	}

	const table = {
		startY: 120,
		theme: 'plain',
		headStyles: {
			fillColor: [255, 255, 255],
			textColor: [0, 0, 0],
			lineColor: [0, 0, 0],
			font: 'TimesNewRoman',
		},
		bodyStyles: {
			fillColor: [255, 255, 255],
			textColor: [0, 0, 0],
			lineColor: [0, 0, 0],
			font: 'TimesNewRoman',
		},
		head: [
			[
				'п/п',
				'Наименование',
				'Тип подписи',
				'Должность',
				'ФИО подписанта',
				'Дата подписания',
				'Реквизиты подписи',
				'Результат',
			],
		],
		body: getTableBody(),
	}

	const result = {
		text: `Документооборот ${ds_signing_at ? 'завершен' : 'не завершен'}`,
		x: 105,
		y: 200,
	}

	const logo = {
		x: 272,
		y: 5,
		size: 20,
		format: letter.LETTER_LOGO_PNG,
		image: get(letterLogo, 'default'),
	}

	return {
		opening,
		heading,
		subHeading,
		body,
		table,
		result,
		logo,
	}
}
